<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import { operPubilc } from "@/api/auth/public";
import cTable from "@/base/common/index";
export default {
  name: "publicAuth",
  components: {
    cTable,
  },
  async mounted() {},
  methods: {},
  data() {
    return {
      methods: {
        list: (p) => {
          p["method"] = p["method"] ? p["method"] : "get";
          return operPubilc(p);
        },
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              row["method"] = row.id ? "PUT" : "POST";
              console.log(row);
              this.$page.handleRequestMethods("list", row, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  type: "string",
                  message: "name cannot be empty",
                  trigger: "blur",
                },
              ],
              path_uri: [
                {
                  required: true,
                  type: "string",
                  message: "code cannot be empty",
                  trigger: "blur",
                },
              ],
              remark: [
                {
                  required: false,
                  type: "string",
                  message: "code cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ title: 24 }, { path_uri: 24 }, { remark: 24 }],
          fields: [
            {
              key: "title",
              name: this.$t("menuName"),
              component: "Input",
              placeholder: this.$t("enter") + this.$t("menuName"),
            },
            {
              key: "path_uri",
              name: this.$t("menuRouting"),
              component: "Input",
              placeholder: this.$t("enter") + this.$t("menuRouting"),
            },
            {
              key: "remark",
              name: this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder: this.$t("enter") + this.$t("Remarks"),
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add",
              },
            },
          ],
          methods: {
            addFun({ field, searchForm }) {
              console.log(this);
              this.getModal("add").open(null, function () {
                this.setTitle(this.$t("add"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: "id",
          key: "id",
          align: "center",
          minWidth: 150,
        },
        {
          name: this.$t("menuName"),
          key: "title",
          align: "center",
          minWidth: 100,
        },
        {
          name: this.$t("Remarks"),
          key: "remark",
          align: "center",
          minWidth: 120,
        },
        {
          name: this.$t("menuRouting"),
          key: "path_uri",
          align: "center",
          minWidth: 120,
        },
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
            },
          ],

          methods: {
            async updateFun({ row }) {
              let data = {
                methods: "get",
                id: row.id,
              };
              let res = await this.handleRequestMethods("list", data);
              this.getModal("add").open(
                {
                  id: row.id,
                  title: res.payload.title,
                  remark: res.payload.remark,
                  path_uri: res.payload.path_uri,
                },
                function () {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("menuName") +
                  row.title +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete",
                    },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
